/** First user-visible character for topic list avatars (letters uppercased; emoji kept intact). */
const startsWithLetter = /^\p{L}/u;

export function topicAvatarGlyph(name: string): string {
  const t = name.trim();
  if (!t) return "#";

  let first: string;
  if (typeof Intl !== "undefined" && "Segmenter" in Intl) {
    const iter = new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(t)[Symbol.iterator]();
    const { value, done } = iter.next();
    first = done || !value ? "" : value.segment;
  } else {
    const cp = t.codePointAt(0);
    first = cp === undefined ? "" : String.fromCodePoint(cp);
  }

  if (!first) return "#";
  if (startsWithLetter.test(first)) {
    return first.toLocaleUpperCase();
  }
  return first;
}
